import React from 'react';
import { Route, Switch } from 'react-router-dom';
import withTracker from './utils/withTracker';
import Base from './pages/Base';

import Home from './pages/Home';
import Interview from './pages/Interview';
import PageNotFound from './pages/PageNotFound';

export default class Routes extends React.Component {
  render() {
    return (
      <Base>
        <Switch>
          <Route exact path="/" component={withTracker(Home)} />
          <Route exact path="/interview/:id" component={withTracker(Interview)} />
          <Route component={PageNotFound} />
        </Switch>
      </Base>
    );
  }
}
